import { http, httpOauth } from 'src/services/auth/http'
import * as type from './type'
import { generatePKCEPair } from './pkce'

export * from './type'
export * from './pkce'

export const getOauthClients = ({
  perPage = 15,
  ...params
}: type.IGetOauthClients) =>
  http.get('/oauth-clients', { params: { perPage, ...params } })

export const postOauthLogib = (data: type.IPostOauthClients) => {
  return http.post('oauth/', data)
}

export async function getOauthAuthorize(
  params: type.IOauthAuthorizeParams
): Promise<{ codeVerifier?: string }> {
  let codeVerifier: string | undefined

  const requestParams: Record<string, string> = {
    response_type: 'code',
    client_id: params.clientId,
    redirect_uri: params.redirectUri,
  }

  if (params.state) {
    requestParams.state = params.state
  }

  if (params.scope) {
    requestParams.scope = params.scope
  }

  if (params.token) {
    requestParams.token = params.token
  }

  if (params.codeChallenge) {
    requestParams.code_challenge = params.codeChallenge
    requestParams.code_challenge_method = params.codeChallengeMethod || 'S256'
  } else {
    const pkcePair = await generatePKCEPair()
    codeVerifier = pkcePair.codeVerifier
    requestParams.code_challenge = pkcePair.codeChallenge
    requestParams.code_challenge_method = 'S256'
  }

  const queryString = new URLSearchParams(requestParams).toString()
  const authUrl = `${httpOauth.defaults.baseURL}/oauth/authorize?${queryString}`

  window.location.href = authUrl

  return { codeVerifier }
}

export const postOauthToken = (data: type.IOauthTokenRequest) => {
  return httpOauth.post('/oauth/token', {
    ...data,
    grant_type: 'authorization_code',
  })
}
